module.exports = __webpack_public_path__ + "img/Wesley van Heije.866cc026.jpg";